<template>
  <CField :modelValue="model">
    <template #default>
      <CToggleButton :active="model" :disabled @update:active="toggle" class="c-large-check-button">
        <CIcon name="check" class="c-large-check-button-icon"/>
        <slot/>
      </CToggleButton>
    </template>
  </CField>
</template>

<script setup lang="ts">
  import { useAttrs } from 'vue';
  import CIcon from '../CIcon.vue';
  import CToggleButton from '../buttons/CToggleButton.vue';
  import CField from './CField.vue';

  const attrs = useAttrs();

  defineProps<{
    disabled?: boolean,
  }>();

  const model = defineModel<boolean>();

  function toggle(v: boolean): void {
    if (!attrs.onClick) model.value = v;
  }
</script>

<style lang="scss">
  .c-large-check-button {
    width: 100%;

    &-icon {
      border: 2px solid $primary;
      border-radius: $border-radius;
      color: $neutral-0;

      .c-icon {
        visibility: hidden;
      }
    }

    &.c-toggle-button {
      color: $neutral-700;
      font-weight: $font-weight-normal;
      border: 1px solid $border-color;

      &.c-button-main-primary:hover:not(.c-button-disabled), &.c-button-normal-primary:hover:not(.c-button-disabled) {
        color: unset;
        border-color: $neutral-500;
      }

      &.c-button-main-primary:hover:not(.c-button-disabled) {
        background-color: unset;
      }

      &-active {
        &:not(.c-button-disabled) {
          background-color: $primary-100;
        }

        .c-large-check-button-icon {
          background-color: $primary;

          .c-icon {
            visibility: visible;
          }
        }
      }
    }

    &.c-button-disabled {
      color: $disabled-fg;

      .c-large-check-button-icon {
        border: 2px solid $disabled-fg;
        color: $neutral-100;
      }

      &.c-toggle-button-active .c-large-check-button-icon {
        color: $disabled-fg;
        background-color: transparent;
      }
    }
  }
</style>
